<div class="row pb-1 mr-0 ml-0" *ngIf="itemsNumber > 0">

    <div class="col-sm-12 text-center pb-1 mb-1 bg-lemken text-white">
        <span class="ml-0 font-weight-bold" *ngIf="itemsNumber > 1">{{ 'filterPage.configurations' | translate }}</span>
        <span class="ml-0 font-weight-bold" *ngIf="itemsNumber == 1">{{ 'filterPage.configuration' | translate }}</span>
    </div>
    <ng-template ngFor let-info
                 [ngForOf]="infoTabs[index]">
        <div class="col-sm-4 text-left pb-1 mb-1 border-bottom">
            <span class="ml-0 font-weight-bold">{{ info.label }}</span>
        </div>
        <div class="col-sm-8 text-left  pb-1 mb-1 font-weight-bold border-bottom">
            <div [ngClass]="getClassUI(info)">
                {{ info.value }}
            </div>
        </div>
    </ng-template>

</div>

<div class="pb-1 row align-items-center" *ngIf="itemsNumber > 1">
    <div class="col">
        <button type="button"  (click)="previousPage()"  [disabled]="index == 0"
                class="btn btn-lemken font-weight-bold ">
            <fa-icon icon="arrow-left" size="2x" [fixedWidth]="true"></fa-icon>
        </button>
    </div>
    <div class="col text-center text-lemken font-weight-bold">
        {{ index + 1 }} / {{ itemsNumber }}
    </div>
    <div class="col text-right">
        <button type="button" (click)="nextPage()" [disabled]="index == itemsNumber - 1"
                class="btn btn-lemken font-weight-bold">
            <fa-icon icon="arrow-right" size="2x" [fixedWidth]="true"></fa-icon>
        </button>
    </div>
</div>

